import React, { useRef, useState, useEffect } from "react";
import "./courseImg.css";
import { UploadCourseFile } from "./UploadCourseFile";

const CourseVideo = ({
  courseVideoFileLimit,
  courseImage,
  courseVideoFile,
  getEdit,
  current,
  history,
  uploadedFileID,
  isCurrentFileUploadStatus,
  isCurrentFileUpload,
}) => {
  const fileInputRef = useRef();
  const courseVidRef = useRef();

  const [showCourseVideo, setShowCourseVideo] = useState(false);
  const [videoFile, setVideoFile] = useState([]);
  const [playPreview, setPlayPreview] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [validFiles, setValidFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let filteredArr = selectedFiles.reduce((file, current) => {
      const x = file.find((item) => item.name === current.name);
      if (!x) {
        return file.concat([current]);
      } else {
        return file;
      }
    }, []);
    setValidFiles([...filteredArr]);
  }, [selectedFiles]);

  useEffect(() => {
    if (current === 16) {
      if (!courseVidRef?.current?.paused) {
        courseVidRef && courseVidRef.current && courseVidRef.current.pause();
      }
    }
  }, [current]);

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const dragOver = (e) => {
    preventDefault(e);
  };

  const dragEnter = (e) => {
    preventDefault(e);
  };

  const dragLeave = (e) => {
    preventDefault(e);
  };

  const fileDrop = (e) => {
    preventDefault(e);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  const filesSelected = () => {
    if (fileInputRef.current.files.length) {
      handleFiles(fileInputRef.current.files);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleFiles = (files) => {
    for (
      let i = 0;
      i < files.length && selectedFiles.length < courseVideoFileLimit;
      i++
    ) {
      if (validateFile(files[i])) {
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
      } else {
        files[i]["invalid"] = true;
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
      }
    }
  };

  const validateFile = (file) => {
    const validTypes = ["video/mp4", "video/mov"];
    const filesize = Math.round(file.size / 1024);

    if (validTypes.indexOf(file.type) === -1) {
      setErrorMessage(
        "Sorry, that file type is not permitted. Please use MP4 or MOV"
      );
      return false;
    } else if (filesize > 50000) {
      setErrorMessage(
        "Sorry, that file is too big. Please keep it to less than 50 MB"
      );
      return false;
    }
    return true;
  };

  const fileType = (fileName) => {
    return (
      fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) ||
      fileName
    );
  };

  const removeFile = (name) => {
    const newSelectedFiles = selectedFiles.filter((el) => el.name !== name);
    setSelectedFiles(newSelectedFiles);
    courseVideoFile(newSelectedFiles);
    setShowCourseVideo(false);
    setVideoFile([]);
    fileInputRef.current.value = "";
  };

  const fileSize = (size) => {
    if (size === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseInt(size / Math.pow(k, i)) + " " + sizes[i];
  };

  const handlePlayVideo = (e) => {
    preventDefault(e);
    if (courseVidRef.current.paused) {
      courseVidRef.current.play();
      setPlayPreview(true);
    } else {
      courseVidRef.current.pause();
      setPlayPreview(false);
    }
  };

  const viewAttachment = (file) => {
    let reader = new FileReader();

    reader.onload = (e) => {
      let newSelectedAttachment = {};
      newSelectedAttachment.file = file;
      newSelectedAttachment.blobData = e.target.result;

      if (file.type.includes("video")) {
        setShowCourseVideo(false);

        setVideoFile([newSelectedAttachment.blobData]);
        // courseVideoFile(reader.result);
        setShowCourseVideo(true);
      }
    };

    reader.readAsDataURL(file);
  };

  const openVideoModal = (file) => {
    if (!file.invalid) {
      viewAttachment(file);
    }
  };

  const readImageFile = (file) => {
    const reader = new FileReader();
    reader.onload = function (e) {};

    reader.readAsDataURL(file);
  };

  const handleDeleteVideo = () => {
    setSelectedFiles([]);
    setShowCourseVideo(false);
    fileInputRef.current.value = "";
  };

  const truncate = (str) => {
    return str.length > 10 ? str.substring(0, 30) + "..." : str;
  };

  const setFormState = (files) => (uploadedData) => {
    courseVideoFile(files);
  };

  return (
    <>
      <div className="course_main">
        <h3 className="course_heading">
          Upload your course intro video video here. Think of it as a commercial
          starring you!
        </h3>
        <br />
        <h4 className="course_image-drop-text">
          Accepted video formats are MP4 and MOV. The max file size 50 MB.
        </h4>
        <div>
          <div
            className="course_image-drop-container"
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            onClick={fileInputClicked}
          >
            <div className="course_drop-message">
              <div className="course_upload-icon"></div>
              <span className="course_image-drop-text">
                Drag and drop or browse to choose a file
              </span>
            </div>
            <input
              ref={fileInputRef}
              className="course_file-input"
              type="file"
              accept="video/mp4, video/mov"
              onChange={filesSelected}
            />
          </div>

          <div>
            {validFiles.map((data, i) => {
              return (
                <div key={i}>
                  <UploadCourseFile
                    storageType="CourseVideos"
                    file={data}
                    openPreviewModal={openVideoModal}
                    removeFile={removeFile}
                    setFormState={setFormState(validFiles)}
                    isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                    isCurrentFileUpload={isCurrentFileUpload}
                    fileID={uploadedFileID}
                    courseId={
                      history.location.state
                        ? history.location.state.courseId
                        : 0
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {showCourseVideo && (
        <div className="course_modal-dialog">
          <div className="course_modal-content">
            <div className="course_modal-body">
              <div className="align-image">
                <ul>
                  <li>
                    <img
                      src="https://cdn.edusity.com/icons/icon-refresh.svg"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      onClick={handleDeleteVideo}
                      src="https://cdn.edusity.com/icons/icon-trash.svg"
                      alt=""
                    />
                  </li>
                </ul>
              </div>

              <div className="preview-thumbnail" onClick={handlePlayVideo}>
                {!playPreview && (
                  <div className="preview-inner">
                    <div className="play-icon-contanier">
                      <img
                        className="play-icon"
                        src="https://cdn.edusity.com/edusityUI/icons/icon_video_play.svg"
                        alt="play-button"
                      />
                    </div>
                  </div>
                )}
                <video id="refVid" ref={courseVidRef} controls={true}>
                  <source src={videoFile[0]} type={videoFile[0].type}></source>
                </video>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CourseVideo;
